import styled from "@emotion/styled/macro";
import { Accordion, AccordionSummary, Box } from "@mui/material";
import isStyledPropsValid from "utils/isStyledPropsValid";

export const StyledWhiteCardContainer = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  background: theme.customColors.white,
  boxShadow: "0px 1.2824229001998901px 6.412113666534424px 0px #0000001A",
  borderRadius: "4px",
  position: "relative",
}));

export const StyledAddContract = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  border: `1px dashed ${theme.customColors.purple[500]}`,
  fontSize: "14px",
  color: theme.customColors.purple[500],
  fontWeight: 700,
  padding: "18px 16px",
  display: "flex",
  alignItems: "center",
  borderRadius: "4px",
  marginTop: "16px",
  cursor: "pointer",
  background: theme.customColors.white,
}));
